<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <div class="main">
      <navMenu :active="active"></navMenu>
      <div class="content badge-content">
        <div class="badge-title">扫一扫</div>
        <div class="badge-infor">
          <img class="suc-icon" :src="sucIcon" alt="" />
          <p class="tips">
            提交成功主办方将在收集截止后3个工作日内开通，请耐心等待
          </p>
          <div class="btn" @click="toPath">返回修改信息</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import top from "../components/top.vue"; //头部
import navMenu from "../components/navMenu.vue"; //左侧步骤条
export default {
  components: { top, navMenu },
  name: "scan",
  data() {
    return {
      active: 3,
      sucIcon: require("../assets/icon_suc.jpg"),
    };
  },
  mounted() {
    let stepMenuList = JSON.parse(localStorage.getItem("menu"));
    this.stepMenuList = stepMenuList;
    var index = stepMenuList.findIndex(function (item) {
      return item.link_url == "conference" && item.id == 11;
    });
    this.active = index;
  },
  created() {},
  methods: {
    toPath(){
      this.$router.back();
    }
  },
};
</script>

<style lang="scss" scoped>
.badge-content {
  .badge-title {
    font-weight: 500;
    font-size: 16px;
    color: #354052;
    line-height: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .badge-infor {
    height: 100%;
    font-size: 14px;
    color: #1d1d1d;
    line-height: 20px;
    padding: 56px 20px;
    background: #fff;
    border-radius: 10px;
    margin: 30px 0 15px;
    .suc-icon {
      width: 77px;
      height: 77px;
      display: block;
      margin: 0 auto;
    }
    .tips {
      width: 604px;
      height: 40px;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.88);
      text-align: center;
      line-height: 40px;
      margin: 25px auto 80px;
      background: #f6ffed;
      border-radius: 8px;
      border: 1px solid #d9f7be;
    }
    .btn {
      width: 126px;
      height: 40px;
      color: #fff;
      font-size: 14px;
      text-align: center;
      line-height: 40px;
      background: #fc933f;
      border-radius: 6px;
      margin: 0 auto;
      cursor: pointer;
    }
  }
}
</style>